import { Paper, Title } from '@mantine/core';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { TagUsage } from '../types';

interface TagUsageChartProps {
    data: TagUsage[];
}

const COLORS = ['#228be6', '#40c057', '#fab005', '#fd7e14', '#e64980', '#be4bdb', '#15aabf', '#82c91e'];

export const TagUsageChart = ({ data }: TagUsageChartProps) => {
    return (
        <Paper p="md" withBorder>
            <Title order={4} mb="md">Tag Usage</Title>
            <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                    <Pie
                        data={data}
                        dataKey="count"
                        nameKey="tagName"
                        cx="50%"
                        cy="50%"
                        outerRadius={80}
                        label
                    >
                        {data.map((_, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>
        </Paper>
    );
};
